var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Transform, Type } from 'class-transformer';
import { IsArray, IsNumber, IsObject, IsOptional, IsString } from 'class-validator';
import { SortQuery } from './sort-query.js';
export class PaginationQuery {
    skip;
    take;
    readNotification;
    filters;
    sort;
    relations;
    returnTypeName;
}
__decorate([
    IsNumber(),
    Transform(({ value }) => (value == null ? undefined : Number.parseInt(String(value)) || 0)),
    Expose(),
    IsOptional(),
    __metadata("design:type", Number)
], PaginationQuery.prototype, "skip", void 0);
__decorate([
    IsNumber(),
    Transform(({ value }) => (value == null ? undefined : Number.parseInt(String(value)) || 0)),
    Expose(),
    IsOptional(),
    __metadata("design:type", Number)
], PaginationQuery.prototype, "take", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", String)
], PaginationQuery.prototype, "readNotification", void 0);
__decorate([
    IsArray(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Array)
], PaginationQuery.prototype, "filters", void 0);
__decorate([
    IsObject(),
    Type(() => SortQuery),
    IsOptional(),
    Expose(),
    __metadata("design:type", SortQuery)
], PaginationQuery.prototype, "sort", void 0);
__decorate([
    IsArray(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], PaginationQuery.prototype, "relations", void 0);
__decorate([
    IsOptional(),
    IsString(),
    Expose(),
    __metadata("design:type", String)
], PaginationQuery.prototype, "returnTypeName", void 0);
//# sourceMappingURL=pagination-query.js.map